import { Box, Chip } from '@mui/material';
import type { Size } from '../../../../api/size';
import {
  CUSTOMER_SIZE_ID,
  CUSTOM_SIZE_ID,
  formatSizePresetSummary,
} from '../../../utils/size';

export interface SizePickerProps {
  sizes: Size[];
  value: string;
  onChange: (sizeId: string) => void;
}

const SizePicker = ({ sizes, value, onChange }: SizePickerProps) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
    <Chip
      label="Use customer size"
      clickable
      onClick={() => onChange(CUSTOMER_SIZE_ID)}
      variant={value === CUSTOMER_SIZE_ID ? 'filled' : 'outlined'}
      color={value === CUSTOMER_SIZE_ID ? 'primary' : 'default'}
    />
    {sizes.map((size) => {
      const sizeId = String(size.id);
      const selected = value === sizeId;
      return (
        <Chip
          key={size.id}
          label={size.name}
          title={formatSizePresetSummary(size)}
          clickable
          onClick={() => onChange(sizeId)}
          variant={selected ? 'filled' : 'outlined'}
          color={selected ? 'primary' : 'default'}
        />
      );
    })}
    <Chip
      label="Custom"
      clickable
      onClick={() => onChange(CUSTOM_SIZE_ID)}
      variant={value === CUSTOM_SIZE_ID ? 'filled' : 'outlined'}
      color={value === CUSTOM_SIZE_ID ? 'primary' : 'default'}
    />
  </Box>
);

export default SizePicker;
